import * as React from 'react';

import CardSlider from 'components/CardSlider';
import useLiveData from 'hooks/useLiveData';
import { useStaticQuery, graphql } from 'gatsby';

const CardSliderProvider = (props) => {
	const data = useStaticQuery(graphql`
		query cardSliders {
		  allSmartTagsCardSlider {
		    edges {
		      node {
		        id
		        flush
		        title
				link
				linkText
		        source
		      }
		    }
		  }
		}
	`);
	const {response} = useLiveData({
		namespace: 'SmartTags',
		model: 'CardSlider',
		method: 'all',
		staticData: data,
		graphqlKey: 'allSmartTagsCardSlider',
	});
	if (response.data.length === 0)return null;
	let attr;
	for (let item of response.data) {
		if (item.id === props.id)attr = item;
	}
	if (!attr)return null;
	return <CardSlider {...attr} />
}

export default CardSliderProvider;